<template>
  <div class="mb-3 card ">
    <div class="card-header bg-secondary-3">
      Áreas de interés:
      <b>
        {{ value.area.name | empty }}
      </b>
    </div>
    <div class="card-body bg-secondary-3">
      <div>
        <div class="font-weight-bold">Indicadores Funcionales Observados:</div>
        <div class="data-name">{{ value.area.description | empty }}</div>
      </div>
      <div class="my-3">
        <label class="data-name">Resultados:</label>
        <p v-if="isReadOnly">{{ model.comment | empty }}</p>
        <validation-provider v-else v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="model.comment"
            :count-classes="['d-block', 'small-counter', 'text-right']"
            custom-error-msg="El campo es requerido."
            :error="errors[0]"
            :maxlength="5000"
            show-char-count
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomTextArea from 'CustomTextArea';

export default {
  name: 'AreaItem',
  components: {
    ValidationProvider,
    CustomTextArea,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style scoped></style>
